export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;

// Informações da aplicação
export const APP_TITLE = "Fercci - Raízes firmes, negócios sólidos";
export const APP_LOGO = "/images/logos/Fercci_AssinaturaVisual_SerenoeSeiva.png";
export const APP_LOGO_ALT_LIGHT = "/images/logos/Fercci_AssinaturaVisual_AuroraeBranco.png";
export const APP_LOGO_ALT_DARK = "/images/logos/Fercci_AssinaturaVisual_Preto.png";

// Informações de contato
export const CONTACT_EMAIL = "contato@fercci.com.br";
export const CONTACT_PHONE = "61991170072";
export const CONTACT_WHATSAPP = "https://api.whatsapp.com/send/?phone=5561991170072&text=ol%C3%A1%2C+gostaria+de+mais+informa%C3%A7%C3%B5es&type=phone_number&app_absent=0";
export const CONTACT_ADDRESS = "SAAN - Brasília, DF, 70632-100";
export const CONTACT_HOURS = "Seg - Sex: 8:00 às 18:00";

// Redes sociais
export const SOCIAL_INSTAGRAM = "https://instagram.com/fercciagro";
export const SOCIAL_LINKEDIN = "https://www.linkedin.com/company/fercci/";

// Formspree
export const FORMSPREE_ORCAMENTO = "https://formspree.io/f/YOUR_FORM_ID_1";
export const FORMSPREE_PARCEIRO = "https://formspree.io/f/YOUR_FORM_ID_2";
export const FORMSPREE_CONTATO = "https://formspree.io/f/YOUR_FORM_ID_3";

// Cores da marca (Brandbook Fercci)
export const COLORS = {
  sereno: "#003B4A",      // Cor principal
  aurora: "#D3D655",      // Amarelo/CTA
  seiva: "#1D8649",       // Verde
  colheita: "#C7893E",    // Laranja
  brisa: "#9FCFCA",       // Azul claro
  branco: "#F2F2F2",      // Branco
} as const;
